var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDotGrid = function SvgDotGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240 240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDD",
    cx: 8,
    cy: 8,
    r: 3
  })))));
};
export default __webpack_public_path__ + "static/dot-grid.b4a82ad6.svg";
export { SvgDotGrid as ReactComponent };